module.exports = __webpack_public_path__ + "img/logo.7eb263e4.png";